export default __webpack_public_path__ + "static/media/search.d57d8d6a.svg";